import { useSelectTheme } from "../../../store/state/theme";
import { defaultSvgProps, SvgProps } from "../type/props";

export const PlayIcon = (props?: SvgProps) => {
  const { color } = useSelectTheme();
  const { width, height, fill, style } = defaultSvgProps(props, {
    width: 20,
    height: 20,
    fill: color.textIcon.title,
    style: {
      flexShrink: 0,
    },
  });

  return (
    <svg
      width={width}
      height={height}
      style={style}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_35179_17658)">
        <path
          d="M8.33329 13.7498L13.3333 9.99984L8.33329 6.24984V13.7498ZM9.99996 1.6665C5.39996 1.6665 1.66663 5.39984 1.66663 9.99984C1.66663 14.5998 5.39996 18.3332 9.99996 18.3332C14.6 18.3332 18.3333 14.5998 18.3333 9.99984C18.3333 5.39984 14.6 1.6665 9.99996 1.6665ZM9.99996 16.6665C6.32496 16.6665 3.33329 13.6748 3.33329 9.99984C3.33329 6.32484 6.32496 3.33317 9.99996 3.33317C13.675 3.33317 16.6666 6.32484 16.6666 9.99984C16.6666 13.6748 13.675 16.6665 9.99996 16.6665Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_35179_17658">
          <rect width={width} height={height} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
